
import React, { Fragment } from 'react';
import './useragreement.scss';

export class UserCheckbox extends React.Component {
  constructor(props) {
    super(props);
    this.state ={
      complete:true,
      openAgreement:false
    }
  }

  componentDidMount(){
    this.props.onRef(this)
  }

  //打开用户协议
  getAgreement = () =>{
    this.setState({
      openAgreement:!this.state.openAgreement
    })
  }

  loginAlert = () =>{
    const title = this.props.title;
    const subtitle = (title ==="用户登录协议")?"登录":"开户";
    if(!this.state.complete || this.state.openAgreement){
      return this.props.openAlert(`${subtitle}失败，尚未勾选同意《${title}》`)
    }
  }

  render() {
    return (
      <Fragment>
        <div className="user-agreement">
          <input type="checkbox" readOnly checked={this.state.complete} onClick={()=>{this.setState({complete:!this.state.complete})}}/>
          <p onClick={this.getAgreement}>已阅读并同意《{this.props.title}》</p>
        </div>
        {
          this.state.openAgreement &&
          <UserAgreement title ={this.props.title} agrContent ={this.props.agrContent} getAgreement={this.getAgreement}/>
        }
      </Fragment>
    );
  }
}

export class ServiceBox extends React.Component {
  constructor(props) {
    super(props);
    this.state ={
      isSelect:true,
      isOpenAgr:false
    }
  }
  //勾选用户协议
   toggleSelect = (e) => {
     e.stopPropagation()
     this.setState({
      isSelect:!this.state.isSelect
     })
   }
  
   //打开协议
   getAgreement = (e) => {
    e.stopPropagation()
    this.setState({
      isOpenAgr:!this.state.isOpenAgr
    })
  }
  
  linkServices = () =>{
    if(!this.state.isSelect){
      this.props.openAlert('无法访问客服系统，尚未勾选同意《客服系统使用协议》')
    }else if(this.state.isOpenAgr){
      this.props.openAlert('无法访问客服系统，请点击确认《客服系统使用协议》')
    }else{
      window.open(this.props.settings.customer_service_url)
    }
  }
   
  render() {
    const kfclassName = "kfServices " + this.props.myClassName + "";
    return (
      <Fragment>
      <div className ={kfclassName} onClick={this.linkServices}>
        <div className="seragreement">
          <div className="serCheckbox">
            <input type="checkbox" readOnly checked={this.state.isSelect} onClick={this.toggleSelect}/>
            <span onClick={this.getAgreement}>同意《客服协议》</span>
          </div>
          <p>在线客服</p>
        </div>
      </div>
      {
        this.state.isOpenAgr&&<UserAgreement title ="客服系统使用协议" agrContent ={this.props.settings.agreement} getAgreement={this.getAgreement}/>
      }
    </Fragment>
    );
  }
}

class UserAgreement extends React.Component {
  constructor(props) {
    super(props);
    this.state ={
      isSelect:true
    }
  }
  //勾选用户协议
   toggleSelect = () => {
     this.setState({
      isSelect:!this.state.isSelect
     })
   }
 
  render() {
   const {title,agrContent,getAgreement}=this.props;
    return (
      <Fragment>
         <div className="contentWrap">
          <h1 className="agrTitle">{title}</h1>
          <div className="agrContent" dangerouslySetInnerHTML={{__html:agrContent}}></div>
          <div className="agrCheckbox">
            <input type="checkbox" checked={this.state.isSelect} onClick ={this.toggleSelect}/>
            <p onClick={this.getAgreement}>已阅读并同意《{title}》</p>
          </div>
          {
            this.state.isSelect?<div className="agrComfirm" onClick={getAgreement}>确认</div>:<div className="agrComfirm comColor">确认</div>
          }
         </div>
      </Fragment>
    );
  }
}
